import vbDiThayDoiStatusIndex from "../views/setting/quanLyThayDoiStatusVbDi/vb-di-thay-doi-status-index";
import improperAccessCheckingService from "../services/improperAccessCheckingService";
import Constants from "../constants";

export default [
  {
    path: "/app/:userDeptRoleId/setting/cauHinhLuong",
    component: () => import("../views/setting/CauHinhLuong/CauHinhLuongIndex"),
    name: "CauHinhLuong",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_LUONGVANBAN)
    }
  },
  {
    path: "/app/:userDeptRoleId/setting/cauHinhLuong/create",
    component: () => import("../views/setting/CauHinhLuong/DiagramNew"),
    name: "CauHinhLuongCreate",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_LUONGVANBAN)
    }
  },
  {
    path: "/app/:userDeptRoleId/setting/cauHinhLuong/edit/:id",
    component: () => import("../views/setting/CauHinhLuong/DiagramNew"),
    name: "CauHinhLuongEdit",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_LUONGVANBAN)
    }
  },
  {
    path: "/app/:userDeptRoleId/setting/quanTriUser",
    component: () => import("../views/setting/quanTriUser/index.vue"),
    name: "quanTriNguoiDung",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_QUANTRINGUOIDUNG)
    }
  },
  {
    path: "/app/:userDeptRoleId/setting/quanTriUser/detail/:id",
    components: {
      default: () => import("../views/setting/quanTriUser/index.vue"),
      detail: () => import("../views/setting/quanTriUser/detail.vue")
    },
    name: "QuanTriNguoiDungDetail",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_QUANTRINGUOIDUNG)
    }
  },
  // quan tri tenant
  {
    path: "/app/:userDeptRoleId/setting/quanTriTenant",
    component: () => import("../views/setting/quanLyTenant/index.vue"),
    name: "quanLyTenant",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_QUANLYTENANT)
    }
  },
  {
    path: "/app/:userDeptRoleId/setting/quanLyTenant/detail/:id",
    components: {
      default: () => import("../views/setting/quanLyTenant/index.vue"),
      detail: () => import("../views/setting/quanLyTenant/detail.vue")
    },
    name: "quanLyTenantDetail",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_QUANLYTENANT)
    }
  },
  // Quan tri don vi
  {
    path: "/app/:userDeptRoleId/setting/quanTriDonVi",
    component: () => import("../views/setting/quanTriDonVi/index.vue"),
    name: "QuanTriDonVi",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_QUANTRIDONVI)
    }
  },
  {
    path: "/app/:userDeptRoleId/setting/QuanTriDonVi/detail/:id",
    components: {
      default: () => import("../views/setting/quanTriDonVi/index.vue"),
      detail: () => import("../views/setting/quanTriDonVi/detail.vue")
    },
    name: "QuanTriDonViDetail",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_QUANTRIDONVI)
    }
  },
  // quan ly uy quyen
  {
    path: "/app/:userDeptRoleId/setting/QuanLyUyQuyen",
    components: {
      default: () => import("../views/setting/quanLyUyQuyen/index.vue")
    },
    name: "QuanLyUyQuyen",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_QUANLYUYQUYEN)
    }
  },
  // {
  //   path: "/app/:userDeptRoleId/setting/QuanLyUyQuyen/detail/:id",
  //   components: {
  //     default: () => import("../views/setting/quanLyUyQuyen/task-index.vue"),
  //     detail: () => import("../views/setting/quanLyUyQuyen/detail.vue")
  //   },
  //   name: "QuanLyUyQuyenDetail"
  // },
  // {
  //   path: "/app/:userDeptRoleId/setting/QuanLyUyQuyen/delete/:id",
  //   components: {
  //     default: () => import("../views/setting/quanLyUyQuyen/task-index.vue")
  //     // detail: () => import('../views/setting/quanLyUyQuyen/cancelDialog.vue')
  //   },
  //   name: "QuanLyUyQuyenDelete"
  // },
  //quan ly ngay nghi le
  {
    path: "/app/:userDeptRoleId/setting/thuVienDungChung",
    components: {
      default: () => import("../views/setting/thuVienDungChung/index.vue")
    },
    name: "ThuVienDungChung",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.THUVIEN_VANBANMAU)
    }
  },
  {
    path: "/app/:userDeptRoleId/setting/QuanLyNgayNghiLe",
    components: {
      default: () => import("../views/setting/quanLyNgayNghiLe/index.vue")
    },
    name: "QuanLyNgayNghiLe",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_QUANLYNGAYLE)
    }
  },
  // quan tri danh muc
  {
    path: "/app/:userDeptRoleId/setting/QuanLyDanhMuc",
    components: {
      default: () => import("../views/setting/quanLyDanhMuc/index.vue")
    },
    name: "QuanLyDanhMuc",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_QUANLYDANHMUC)
    }
  },
  // quan tri vai tro
  {
    path: "/app/:userDeptRoleId/setting/quanLyVaiTro",
    components: {
      default: () => import("../views/setting/quanLyVaiTro/index.vue")
    },
    name: "QuanLyVaiTro",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_QUANLYVAITRO)
    }
  },
  {
    path: "/app/:userDeptRoleId/setting/quanLyVaiTro/detail/:id",
    components: {
      default: () => import("../views/setting/quanLyVaiTro/index.vue"),
      detail: () => import("../views/setting/quanLyVaiTro/detail.vue")
    },
    name: "QuanLyVaiTroDetail",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_QUANLYVAITRO)
    }
  },
  {
    path: "/app/:userDeptRoleId/setting/quanLyVaiTro/delete/:id",
    components: {
      default: () => import("../views/setting/quanLyVaiTro/index.vue")
    },
    name: "QuanLyVaiTroDelete",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_QUANLYVAITRO)
    }
  },
  {
    path: "/app/:userDeptRoleId/profile",
    components: {
      default: () => import("../views/setting/profileManagement/index.vue")
    },
    name: "profileManagement"
  },
  {
    path: "/app/:userDeptRoleId/setting/car",
    components: {
      default: () => import("../views/setting/danhMucXe/index.vue")
    },
    name: "danhMucXe",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH)
    }
  },

  {
    path: "/app/:userDeptRoleId/setting/globalConfig",
    components: {
      default: () => import("../views/setting/quanLyGlobalConfig/index.vue")
    },
    name: "globalConfig"
  },

  {
    path: "/app/:userDeptRoleId/setting/quanLyCauHinh",
    components: {
      default: () => import("../views/setting/quanLyCauHinh/index.vue")
    },
    name: "quanLyCauHinh"
  },

  {
    path: "/app/:userDeptRoleId/setting/quanLyCauHinh/detail/:id",
    components: {
      default: () => import("../views/setting/quanLyCauHinh/index.vue")
    },
    name: "quanLyCauHinhDetail"
  },

  {
    path: "/app/:userDeptRoleId/setting/quanLyTruyCap",
    components: {
      default: () => import("../views/setting/quanLyTruyCap/index.vue")
    },
    name: "quanLyTruyCap"
  },

  {
    path: "/app/:userDeptRoleId/setting/quanLyTruyCap/detail/:id",
    components: {
      default: () => import("../views/setting/quanLyTruyCap/index.vue")
    },
    name: "quanLyTruyCapDetail"
  },

  //region Quan ly phong hop
  {
    path: "/app/:userDeptRoleId/setting/quanLyPhongHop",
    components: {
      default: () => import("../views/setting/quanLyPhongHop/index.vue")
    },
    name: "QuanLyPhongHop",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_QUANLYPHONGHOP)
    }
  },
  {
    path: "/app/:userDeptRoleId/setting/quanLyPhongHop/detail/:id",
    components: {
      default: () => import("../views/setting/quanLyPhongHop/index.vue")
    },
    name: "QuanLyPhongHopDetail",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_QUANLYPHONGHOP)
    }
  },
  //endregion

  //region Quan ly tai xe
  {
    path: "/app/:userDeptRoleId/setting/quanLyTaiXe",
    components: {
      default: () => import("../views/setting/quanLyTaiXe/index.vue")
    },
    name: "QuanLyTaiXe",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CAUHINH_QUANLYTAIXE)
    }
  },
  //endregion
  //quan ly tai lieu ca nhan
  // {
  //   path: "/app/:userDeptRoleId/setting/quanLyTaiLieu/:folderId",
  //   component: () => import("../views/setting/quanLyTaiLieu/index.vue"),
  //   name: "QuanLyTaiLieu"
  // },
  // {
  //   path: "/app/:userDeptRoleId/setting/quanLyTaiLieu/:folderId/detail/:id",
  //   components: {
  //     default: () => import("../views/setting/quanLyTaiLieu//index.vue"),
  //     detail: () => import("../views/setting/quanLyTaiLieu/detail.vue")
  //   },
  //   name: "QuanTriTaiLieuDetail"
  // },

  // new
  {
    path: "/app/:userDeptRoleId/setting/quanLyTaiLieuCaNhan/:folderId",
    component: () => import("../views/setting/quanLyTaiLieu/caNhan/index.vue"),
    name: "QuanLyTaiLieuCaNhan",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.QUANLYTAILIEU_CANHAN)
    }
  },
  {
    path: "/app/:userDeptRoleId/setting/quanLyTaiLieuCaNhan/:folderId/detail/:id",
    components: {
      default: () => import("../views/setting/quanLyTaiLieu/caNhan/index.vue"),
      detail: () => import("../views/setting/quanLyTaiLieu/caNhan/detail.vue")
    },
    name: "QuanTriTaiLieuCaNhanDetail",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.QUANLYTAILIEU_CANHAN)
    }
  },
  // quan li tai lieu don vi
  {
    path: "/app/:userDeptRoleId/setting/quanLyTaiLieuDonVi/:folderId",
    component: () => import("../views/setting/quanLyTaiLieu/donVi/index.vue"),
    name: "QuanLyTaiLieuDonVi",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.QUANLYTAILIEU_DONVI)
    }
  },
  {
    path: "/app/:userDeptRoleId/setting/quanLyTaiLieuDonVi/:folderId/detail/:id",
    components: {
      default: () => import("../views/setting/quanLyTaiLieu/donVi/index.vue"),
      detail: () => import("../views/setting/quanLyTaiLieu/donVi/detail.vue")
    },
    name: "QuanTriTaiLieuDonViDetail",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.QUANLYTAILIEU_DONVI)
    }
  },
  //quan li yeu cau luu du lieu
  {
    path: "/app/:userDeptRoleId/yeuCauLuuTaiLieu",
    component: () => import("../views/setting/quanLyTaiLieu/yeuCauLuu/index.vue"),
    name: "QuanLyYeuCauLuuTaiLieu",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.QUANLYTAILIEU_YEUCAULUUTRU)
    }
  },
  {
    path: "/app/:userDeptRoleId/yeuCauLuuTaiLieu/:id",
    components: {
      default: () => import("../views/setting/quanLyTaiLieu/yeuCauLuu/index.vue"),
      detail: () => import("../views/setting/quanLyTaiLieu/yeuCauLuu/detail.vue")
    },
    name: "QuanLyYeuCauLuuTaiLieuDetail",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.QUANLYTAILIEU_YEUCAULUUTRU)
    }
  },
  //quan li phe duyet yeu cau luu du lieu
  {
    path: "/app/:userDeptRoleId/pheDuyetYeuCauLuuTaiLieu",
    component: () => import("../views/setting/quanLyTaiLieu/pheDuyetYeuCauLuu/index.vue"),
    name: "QuanLyPheDuyetYeuCauLuuTaiLieu",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.QUANLYTAILIEU_PHEDUYETYEUCAULUUTRU)
    }
  },
  {
    path: "/app/:userDeptRoleId/pheDuyetYeuCauLuuTaiLieu/:id",
    components: {
      default: () => import("../views/setting/quanLyTaiLieu/pheDuyetYeuCauLuu/index.vue"),
      detail: () => import("../views/setting/quanLyTaiLieu/pheDuyetYeuCauLuu/detail.vue")
    },
    name: "QuanLyPheDuyetYeuCauLuuTaiLieuDetail",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.QUANLYTAILIEU_PHEDUYETYEUCAULUUTRU)
    }
  },
// view folder yêu cầu lưu trữ
  {
    path: "/app/:userDeptRoleId/viewFolderYeuCauLuu",
    component: () => import("../views/setting/quanLyTaiLieu/pheDuyetYeuCauLuu/index.vue"),
    name: "QuanLyPheDuyetYeuCauLuuTaiLieu"
  },
  {
    path: "/app/:userDeptRoleId/pheDuyetYeuCauLuuTaiLieu/:id",
    components: {
      default: () => import("../views/setting/quanLyTaiLieu/pheDuyetYeuCauLuu/index.vue"),
      detail: () => import("../views/setting/quanLyTaiLieu/pheDuyetYeuCauLuu/detail.vue")
    },
    name: "QuanLyPheDuyetYeuCauLuuTaiLieuDetail",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.QUANLYTAILIEU_PHEDUYETYEUCAULUUTRU)
    }
  },
  {
    path: "/app/:userDeptRoleId/setting/vbDiThayDoiStatusIndex",
    name: "vbDiThayDoiStatusIndex",
    component: vbDiThayDoiStatusIndex
  },
  // {
  //   path: "/app/:userDeptRoleId/setting/quanLyCauHinh",
  //   components: {
  //     default: () => import("../views/setting/quanLyCauHinh/index.vue")
  //   },
  //   name: "quanLyCauHinh"
  // },
  //
  // {
  //   path: "/app/:userDeptRoleId/setting/quanLyCauHinh/detail/:id",
  //   components: {
  //     default: () => import("../views/setting/quanLyCauHinh/index.vue")
  //   },
  //   name: "quanLyCauHinhDetail"
  // },

  // quan tri thu ky
  {
    path: "/app/:userDeptRoleId/setting/quanLyThuKy",
    component: () => import("../views/setting/quanLyThuKy/index.vue"),
    name: "quanLyThuKy"
  },
  {
    path: "/app/:userDeptRoleId/setting/quanLyThuKy/detail/:id",
    components: {
      default: () => import("../views/setting/quanLyThuKy/index.vue"),
      detail: () => import("../views/setting/quanLyThuKy/detail.vue")
    },
    name: "quanLyThuKyDetail"
  },
];



// WEBPACK FOOTER //
// ./src/router/setting.js